//
// Standard Free Spins Controller
//
// Handles featureType 1 - Red piggy bank feature
// ----------------------------

(function () {
  class StandardFreeSpinsController {
    constructor() {
      this._active = false;
      this._featureData = null;
      this._spinsLeft = 0;
      this._freespinsCount = 0;
      this._currentSpinIndex = 0;
      this._totalWinnings = 0;
      this._winningsThisSpin = 0;
      this._startHolder = undefined;
      this._endHolder = undefined;
      this._eliminationLevel = -1; // default reels
      this._visualEliminationLevel = -1;
      this._winAmountSoFar = 0;

      // Elimination Graphics
      this._tensElim = undefined;
      this._tensJacksElim = undefined;
      this._tensJacksQueenElim = undefined;
      this._tensJacksQueenKingElim = undefined;
      this._tensJacksQueenKingAceElim = undefined;
      this._tensJacksQueenKingAceCakeElim = undefined;
      this._eliminationGraphics = undefined;

      // Bind event handlers
      this._doSpinFunc = this.doSpin.bind(this);
      this._doSpinDeadFunc = this.doSpinDead.bind(this);
      this._payWinsDeadFunc = this.doPayWinsDead.bind(this);

      messageBus.subscribe('spinner:GameConfigEvent', this.onGameConfigEvent.bind(this));
      messageBus.subscribe('spinner:FreeSpinsDataEvent', this.onFreeSpinsData.bind(this));
      messageBus.subscribe('spinner:FreeSpinsStartEvent', this.onFreeSpinsStart.bind(this));
      messageBus.subscribe('spinner:FreeSpinsStartEventDead', this.onFreeSpinsStartDead.bind(this));
      messageBus.subscribe('spinner:FreeSpinsEndEvent', this.endFeature.bind(this));
      messageBus.subscribe('spinner:FreeSpinsDataEventDead', this.onFreespinsDataDeadEvent.bind(this));
    }

    // Controller initialization
    initialise(json) {
      console.log('StandardFreeSpinsController: Initialised');
      this._tensElim = resourceManager.get('mainReelsContainer:greenRespin2');
      this._tensJacksElim = resourceManager.get('mainReelsContainer:greenRespin3');
      this._tensJacksQueenElim = resourceManager.get('mainReelsContainer:greenRespin4');
      this._tensJacksQueenKingElim = resourceManager.get('mainReelsContainer:greenRespin5');
      this._tensJacksQueenKingAceElim = resourceManager.get('mainReelsContainer:greenRespin6');
      this._tensJacksQueenKingAceCakeElim = resourceManager.get('mainReelsContainer:greenRespin7');

      // Create array of elimination graphics for efficient visibility management
      this._eliminationGraphics = [
        this._tensElim,
        this._tensJacksElim,
        this._tensJacksQueenElim,
        this._tensJacksQueenKingElim,
        this._tensJacksQueenKingAceElim,
        this._tensJacksQueenKingAceCakeElim,
      ];

      // TODO: Set up UI elements and initial state
      // - Link to free spins meter
      // - Set up intro/outro popups
      // - Initialize feature background
    }

    onFreeSpinsData(data) {
      this._winAmountSoFar = data.data.winAmountSoFar;
      // gameController.jackpotView.addLatestWinAmount(data.data.spinWinAmount);
    }

    async upgradeEliminationForBonusBuy(toLevel) {
      // we will be updgrading from 0 to toLevel
      let delay = 0;
      for (let i = 1; i <= toLevel; i++) {
        if (delay) {
          await timerManager.delayAsync(delay);
        }
        soundManager.play('eliminateSymbol');
        const graphic = this.updateEliminationGraphicLevel(i);
        gameController.greenSpinParticles[i].particleEmitter.emit = true;
        await game.tweenFromToAsync(
          graphic.scale,
          {
            x: 1,
            y: 1,
          },
          {
            x: 1,
            y: 1,
            duration: 0.25,
            repeat: 1,
            yoyo: true,
          }
        );
        if (!delay) {
          delay = 750;
        }
        // gameController.greenSpinParticles[i].particleEmitter.emit = false;
      }
    }

    async upgradeRedFreeSpinsForBonusBuy(from, to) {
      const fsIndicator = resourceManager.get('mainReelsContainer:redRespin:freeSpinsText');
      const diff = to - from;

      let delay = 0;

      for (let i = 1; i <= diff; i++) {
        if (delay) {
          await timerManager.delayAsync(delay);
        }
        soundManager.play('increaseFreeSpins');
        gameController.redRespinParticle.particleEmitter.emit = true;
        fsIndicator.setText(from + i);
        await game.tweenFromToAsync(
          fsIndicator.scale,
          {
            x: fsIndicator.scale.x,
            y: fsIndicator.scale.y,
          },
          {
            x: fsIndicator.scale.x * 1.2,
            y: fsIndicator.scale.y * 1.2,
            duration: 0.25,
            repeat: 1,
            yoyo: true,
          }
        );
        if (!delay) {
          delay = 250;
        }
        // gameController.redRespinParticle.particleEmitter.emit = false;
      }
      fsIndicator.setText(to);
    }

    // Main entry point for standard free spins feature
    async onFreeSpinsStart(task) {
      messageBus.subscribe('spinner:SpinEvent', this._doSpinFunc);
      this._featureType = task.data.featureType;
      gameController.featureType = this._featureType;
      this._startHolder = task;
      this._startHolder.join();

      gameController.freeSpinsShutterData = task.data.shutterInfo;

      this._active = true;
      this._totalWinnings = 0;
      this._currentSpinIndex = 0;

      // Get spin count from feature data
      this._freespinsCount = this._startHolder.data.freeSpinsAwarded;
      this._spinsLeft = this._freespinsCount - 1;
      this._eliminationLevel = task.data.eliminationLevel;
      this._visualEliminationLevel = this._eliminationLevel;

      gameController.featureType = this._featureType;

      // before we show the free spins intro pop up
      // check to see if we are bonus buy
      // if we are bonus buy, then we may need to animate the elimination
      // then the red number of spins
      if (
        task.data.mode === 'BONUS_BUY_HIGH' ||
        task.data.mode === 'BONUS_BUY_LOW' ||
        task.data.mode === 'BONUS_BUY_MYSTERY'
      ) {
        if (this._featureType === 3 || this._featureType === 5 || this._featureType === 6 || this._featureType === 7) {
          if (this._eliminationLevel > 0) {
            await this.upgradeEliminationForBonusBuy(this._eliminationLevel);
          }
        }

        if (this._featureType === 1 || this._featureType === 4 || this._featureType === 5 || this._featureType === 7) {
          const startingFS = task.data.mode === 'BONUS_BUY_HIGH' ? 15 : 9;
          if (startingFS < this._freespinsCount) {
            await this.upgradeRedFreeSpinsForBonusBuy(startingFS, this._freespinsCount);
          }
        }
      }

      switch (this._featureType) {
        case 1: // Standard
          this.updateEliminationGraphicLevel(task.data.eliminationLevel);
          break;
        case 2: // Jackpot
          gameController.jackpotView.setJPTrailInfo(task.data.shutterInfo);
          this.updateEliminationGraphicLevel(task.data.eliminationLevel);
          break;
        case 3: // Elimination
          this.setReelEliminationLevel(task.data.eliminationLevel);
          this.updateEliminationGraphicLevel(task.data.eliminationLevel);
          break;
        case 4: // Standard & Jackpot
          gameController.jackpotView.setJPTrailInfo(task.data.shutterInfo);
          this.updateEliminationGraphicLevel(task.data.eliminationLevel);
          break;
        case 5: // Standard & Elimination
          this.setReelEliminationLevel(task.data.eliminationLevel);
          this.updateEliminationGraphicLevel(task.data.eliminationLevel);
          break;
        case 6: // Jackpot & Elimination
          this.setReelEliminationLevel(task.data.eliminationLevel);
          this.updateEliminationGraphicLevel(task.data.eliminationLevel);
          gameController.jackpotView.setJPTrailInfo(task.data.shutterInfo);
          break;
        case 7: // Standard, Jackpot & Elimination
          this.setReelEliminationLevel(task.data.eliminationLevel);
          this.updateEliminationGraphicLevel(task.data.eliminationLevel);
          gameController.jackpotView.setJPTrailInfo(task.data.shutterInfo);
          break;
      }

      // Start feature sequence
      this.startFeature(this._featureType);
    }

    getSpinIndex() {
      return this._currentSpinIndex;
    }

    // Initialize feature display and animations
    async startFeature(featuretype) {
      // Set game state to free spins mode
      gameController.cancelAutoplay();

      resourceManager.getController('inputOverlord').setState('freespinsIntro');

      this._fsActive = true;
      this.updateCountText();

      // Clear dim symbols
      gameController.slotMachine.clearDimSymbolIds();

      await gameController.waitForAllPigUpdatesToFinish();

      await Promise.all([
        this.animateActivatedPigs(featuretype), //
        this.animateDeactivatedPigs(featuretype),
      ]);

      gameController.inFreeSpins = true;

      const buyBonusButton = resourceManager.get('backgroundButtons:buyBonusButton');
      if (buyBonusButton) {
        buyBonusButton.renderable = false;
      }

      this._freeSpinsMeter.visible = true;
      const layout = layoutController.getCurrentLayout();

      if (layout === 'portrait_mobile' || layout === 'portrait_default') {
        // if we are starting free spins in portrait, make sure the title cant
        // be rendered
        resourceManager.get('title').renderable = false;
        // game controller handles the rest
      }

      switch (this._featureType) {
        case 1: // Standard
        case 3: // Elimination
        case 5: // Standard & Elimination
          break;
        case 2: // Jackpot
        case 4: // Standard & Jackpot
        case 6: // Jackpot & Elimination
        case 7: // Standard, Jackpot & Elimination
          gameController.jackpotView.setJPTrailVisibility(true);
          break;
      }

      // Show feature Intro Popup
      this.showFeatureIntro(featuretype);
    }

    async animateActivatedPigs(featuretype) {
      const names = [];
      switch (featuretype) {
        case 1:
          // red
          names[0] = 'red';
          break;
        case 2:
          // blue
          names[0] = 'blue';
          break;
        case 3:
          // green
          names[0] = 'green';
          break;
        case 4:
          // red and blue
          names[0] = 'red';
          names[1] = 'blue';
          break;
        case 5:
          // green and red
          names[0] = 'red';
          names[1] = 'green';
          break;
        case 6:
          // green and blue
          names[0] = 'blue';
          names[1] = 'green';
          break;
        case 7:
          // green blue and red
          names[0] = 'blue';
          names[1] = 'green';
          names[2] = 'red';
          break;
        default:
          // shouldnt get here
          break;
      }
      await gameController.playPigActivateAnimation(names);
    }

    async animateDeactivatedPigs(featuretype) {
      const names = [];
      switch (featuretype) {
        case 1:
          // red
          names[0] = 'blue';
          names[1] = 'green';
          names[2] = 'gold';
          break;
        case 2:
          // blue
          names[0] = 'red';
          names[1] = 'green';
          names[2] = 'gold';
          break;
        case 3:
          // green
          names[0] = 'red';
          names[1] = 'blue';
          names[2] = 'gold';
          break;
        case 4:
          // red and blue
          names[0] = 'green';
          names[1] = 'gold';
          break;
        case 5:
          // green and red
          names[0] = 'blue';
          names[1] = 'gold';
          break;
        case 6:
          // green and blue
          names[0] = 'red';
          names[1] = 'gold';
          break;
        case 7:
          // green blue and red
          names[0] = 'gold';
          break;
        default:
          // shouldnt get here
          break;
      }
      await gameController.playPigDeactivateAnimation(names);
    }

    updateCountText() {
      if (this._fsActive) {
        gameController.freeSpinsNum = this._freespinsCount - this._spinsLeft;
        this._freeSpinsMeter.setMeterValues(this._freespinsCount - this._spinsLeft, this._freespinsCount);
      }
    }

    // Show feature introduction popup
    showFeatureIntro(featureType) {
      console.log('StandardFreeSpinsController: Showing feature intro');

      // depending on feature type, show different intro
      const data = {
        spinsAwarded: this._freespinsCount,
        featureType: featureType,
        eliminationLevel: this._eliminationLevel,
      };

      this._freeSpinsIntro.startIntro(this.introComplete.bind(this), data);
    }

    introComplete() {
      timerManager.addTimeout(50, () => {
        // Set input state and reel mode
        resourceManager.getController('inputOverlord').setState('freespinsEnabled');

        this._startHolder.leave();
        this._startHolder = undefined;
      });
    }

    // Process next spin from pre-determined feature data (hybrid server-driven pattern)
    processNextFeatureSpin() {
      if (this._currentSpinIndex >= this._freespinsCount) {
        return;
      }
    }

    onFreeSpinsStartDead(task) {
      this.getNextSpinOutcome();
    }

    getNextSpinOutcome() {
      this.updateCountText();
      gameController.initNewSpin();
      gdk.getNextGameOutcome(function () {});
    }

    onFreespinsDataDeadEvent(task) {
      this._spinsLeft--;

      this.startNextSpin();
    }

    // Process shutters - swap reel symbols to presents and format data for animations
    processShutters(featureSpin, resultPanel) {
      if (!featureSpin.shutters?.shutters || !Array.isArray(featureSpin.shutters.shutters)) {
        return [];
      }

      const shutterData = [];

      for (let i = 0; i < featureSpin.shutters.shutters.length; i++) {
        const shutter = featureSpin.shutters.shutters[i];

        if (shutter.pos && typeof shutter.pos.reel === 'number' && typeof shutter.pos.row === 'number') {
          const reel = shutter.pos.reel;
          const row = shutter.pos.row;

          // Store the original symbol before swapping (same as base game logic)
          let originalSymbol = 0;
          const symbol = resultPanel.reelList?.[reel]?.symbols?.[row];
          if (symbol) {
            originalSymbol = symbol.value;

            // Swap the symbol to present (ID 15) so it spins in on the reel
            symbol.value = 15;
          }

          // Format shutter data for later use in animations
          shutterData.push({
            reel: reel,
            row: row,
            originalSymbol: originalSymbol,
            revealedSymbols: shutter.revealedSymbols || [],
          });
        }
      }

      return shutterData;
    }

    // Set reel elimination level for the feature and update graphical counters
    setReelEliminationLevel(level) {
      // this.updateEliminationGraphicLevel(level);
      switch (level) {
        case 0:
          gameController.slotMachine.setInjectorMode('no-tens');
          break;
        case 1:
          gameController.slotMachine.setInjectorMode('no-jacks');
          break;
        case 2:
          gameController.slotMachine.setInjectorMode('no-queens');
          break;
        case 3:
          gameController.slotMachine.setInjectorMode('no-kings');
          break;
        case 4:
          gameController.slotMachine.setInjectorMode('no-aces');
          break;
        case 5:
          gameController.slotMachine.setInjectorMode('no-cake');
          break;
        default:
          gameController.slotMachine.setInjectorMode('freespins');
          break;
      }
    }

    // Changed the elimination graphic to reflect the level we are at.
    updateEliminationGraphicLevel(level) {
      // Set visibility: only the graphic at the level index should be visible
      this._visualEliminationLevel = level;
      let foundGraphic = null;
      this._eliminationGraphics.forEach((graphic, index) => {
        if (index === level) {
          foundGraphic = graphic;
          graphic.visible = true;
        } else {
          graphic.visible = false;
        }
      });
      return foundGraphic;
    }

    // Handle spin event
    doSpin(spinTask) {
      gameController.winAmountSoFar = spinTask.data.winAmountSoFar;
      gameController.jackpotWinAmount = spinTask.data.winAmount;
      this._winningsThisSpin = 0;
      this.updateCountText();
      gameController.inFreeSpins = true;
    }

    // Handle spin completion
    doSpinDead(spinTask) {}

    // Handle win processing completion
    doPayWinsDead(payWinsTask) {
      // Win processing is complete, now continue to next spin
      // this.startNextSpin();
    }

    // Determine next action after spin completion
    startNextSpin() {
      this._currentSpinIndex++;
      if (this._winningsThisSpin > 0) {
        this.getNextSpinOutcome();
      } else {
        const self = this;
        timerManager.addTimer(450, undefined, function () {
          self.getNextSpinOutcome();
        });
      }
    }

    // End the free spins feature
    endFeature(task) {
      this._endHolder = task;
      this._endHolder.join();
      // Mark feature as inactive
      this._active = false;

      systemData.hideSpinButtonInPortait = true;
      if (!systemData.isLandscape) {
        resourceManager.get('buttonContainer:buttonBar:spinButton').visible = false;
      }

      resourceManager.getController('inputOverlord').setState('freespinsOutro');

      // Unsubscribe from events
      messageBus.unsubscribe('spinner:SpinEvent', this._doSpinFunc);
      messageBus.unsubscribe('spinner:WinningLinesEventDead', this._payWinsDeadFunc);

      // Return to default reel mode
      gameController.slotMachine.selectReelMode('default');

      // Update game state
      gameController.inFreeSpins = false;
      gameController.fsWinnings = task.data.fsWinnings;
      gameController.totalWinnings = task.data.totalWinnings;

      gameController.slotMachine.setInjectorMode('main'); // back to default reels

      this.showFeatureOutro();
    }

    async showFeatureOutro() {
      // Show feature end popup

      // TODO: Use featurePopupManager to show outro
      // - Show total winnings
      // - Congratulations message
      // - Return to base game button

      // set reels back to normal
      this.setReelEliminationLevel(-1);

      await timerManager.delayAsync(500);
      let outroResolver = null;
      const outroPromise = new Promise((resolve) => {
        outroResolver = resolve;
      });
      this._freeSpinsMeter.visible = false;
      resourceManager.get('title').renderable = true;
      this._freeSpinsOutro.startOutro(() => {
        outroResolver();
      }, gameController.fsWinnings);

      await outroPromise;

      systemData.hideSpinButtonInPortait = false;
      resourceManager.get('buttonContainer:buttonBar:spinButton').visible = true;

      // For now, immediately complete the feature
      if (this.doBigWinCheck() === true) {
        await this.doBigWin();
      }
      this.endFreeSpins();
      this.completeFeature();
    }

    doBigWinCheck() {
      const result = gameController.fullWinningsDisplay.willTriggerBigWin(
        gameController.totalWinnings,
        gameController.inBuyABonus,
        gameController.globalHelperGetStake()
      );
      return result;
    }

    async doBigWin() {
      let bigwinResolver = null;
      const bigwinPromise = new Promise((resolve) => {
        bigwinResolver = resolve;
      });

      gameController.fullWinningsDisplay._winsSkippedThisSpin = false;
      gameController.fullWinningsDisplay.displayWinnings(
        gameController.totalWinnings,
        false, // still needs to be false otherwise you wont see the big win anim, just the count up
        () => {
          bigwinResolver();
        },
        gameController.inBuyABonus,
        gameController.globalHelperGetStake(),
        true,
        true
      );

      await bigwinPromise;
    }

    endFreeSpins() {
      timerManager.addTimeout(50, () => {
        this._endHolder.leave();
        this._endHolder = undefined;
      });
    }

    completeFeature() {
      gameController.piggiesChanged = false;

      const buyBonusButton = resourceManager.get('backgroundButtons:buyBonusButton');
      if (buyBonusButton) {
        buyBonusButton.renderable = true;
      }
      resourceManager.get('backgroundButtons:luckyBetToggleButton').visible = true;
      gameController.inFreeSpins = false;

      // wait a second and then remove the feature trails
      // TODO: Can probably remove this once intro/outro panels are in place
      timerManager.addTimeout(1000, () => {
        gameController.jackpotView.resetJackpotTrailNodes();
        gameController.jackpotView.setJPTrailVisibility(false);
      });

      this.reset();
    }

    reset() {
      // Reset controller state
      this._active = false;
      this._featureData = null;
      this._spinsLeft = 0;
      this._freespinsCount = 0;
      this._currentSpinIndex = 0;
      this._totalWinnings = 0;
      this._winningsThisSpin = 0;
    }

    isActive() {
      return this._active;
    }

    getTotalWinnings() {
      return this._totalWinnings;
    }

    getSpinsRemaining() {
      return this._spinsLeft;
    }

    onGameConfigEvent(task) {
      this._gameTitle = resourceManager.get('title');
      this._freeSpinsMeter = resourceManager.get('freeSpinsMeter');
      this._freeSpinsMeter.visible = false;

      this._freeSpinsIntro = resourceManager.get('freeSpinsIntro');
      this._freeSpinsOutro = resourceManager.get('freeSpinsOutro');

      // TODO: Process configuration data
      // - Update feature settings
      // - Initialize progressive values
    }
  }

  // Register controller with resource manager
  resourceManager.registerController('standardFreeSpinsController', function () {
    return new StandardFreeSpinsController();
  });
})();
